import React from 'react';
import { Bot } from 'lucide-react';
import { AgentRow } from './AgentRow';
import type { AuthorizedAgent } from '@/api/useAgentsApi';

interface Props {
    agents: AuthorizedAgent[];
    orgs: { id: string; name: string }[];
    onRevoke: (agent: AuthorizedAgent) => void | Promise<void>;
    onSetOrgAccess: (agent: AuthorizedAgent, orgId: string, allowed: boolean) => Promise<void>;
    onSetPersonalAccess: (agent: AuthorizedAgent, allowed: boolean) => Promise<void>;
}

export const AgentsList: React.FC<Props> = ({ agents, orgs, onRevoke, onSetOrgAccess, onSetPersonalAccess }) => {
    if (agents.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-20 text-center">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-neutral-100 dark:bg-neutral-800 text-neutral-400 mb-3">
                    <Bot className="h-6 w-6" />
                </div>
                <p className="text-sm text-neutral-500 dark:text-neutral-400">No agents authorized yet.</p>
                <p className="text-xs text-neutral-400 dark:text-neutral-500 mt-1 max-w-sm">
                    Agents appear here after you authorize them from an MCP client (Claude Code, Cursor, …) using Glue's hosted
                    MCP server.
                </p>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2 max-w-3xl mx-auto w-full">
            {agents.map(agent => (
                <AgentRow
                    key={agent.id}
                    agent={agent}
                    orgs={orgs}
                    onRevoke={onRevoke}
                    onSetOrgAccess={onSetOrgAccess}
                    onSetPersonalAccess={onSetPersonalAccess}
                />
            ))}
        </div>
    );
};
